import { AvailabilityTabs } from './AvailabilityTabs'
import { Calendar } from 'lucide-react'

export function BookingSystemAvailability() {
  return (
    <div 
      className="bg-background flex flex-col overflow-hidden"
      style={{ height: 'calc(100vh - var(--bottom-nav-offset))' }}
    >
      {/* Fixed header section - non-scrollable */}
      <div className="flex-shrink-0 phone-container-padded pb-2 w-full">
        {/* Header */}
        <div className="flex items-center justify-between mb-1.5">
          <div className="flex items-center gap-3">
            <Calendar className="w-6 h-6" />
            <h1 className="text-page-title text-foreground">
              Availability
            </h1>
          </div>
          {/* Invisible spacer to maintain row height */}
          <div className="p-2 flex-shrink-0">
            <div className="h-6 w-6" />
          </div>
        </div>
      </div>

      {/* Content */}
      <AvailabilityTabs />
    </div>
  )
}
